export default __webpack_public_path__ + "static/flipImg2-362a025246cdd79922f71ba940bb1c26.webp";